module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-6.adf5bee8.png";